(()=>{"use strict";
const SELECTOR='[data-lm-ewd-popup]';
function init(root){
  if(!root||root.dataset.lmEwdBound==='true')return;
  root.dataset.lmEwdBound='true';
  const campaignEndsAt=Number(root.dataset.lmEwdEnd||0);
  if(!Number.isFinite(campaignEndsAt)||campaignEndsAt<=0)return;
  const designMode=root.dataset.lmEwdDesignMode==='true';
  const storageKey=root.dataset.lmEwdStorageKey||'lm_ewd_2026_seen';
  const repeatMs=Number(root.dataset.lmEwdRepeatMs||43200000);
  const copyButton=root.querySelector('[data-lm-ewd-copy]');
  const closeButton=root.querySelector('[data-lm-ewd-close]');
  const daysNode=root.querySelector('[data-lm-ewd-days]');
  const hoursNode=root.querySelector('[data-lm-ewd-hours]');
  const minutesNode=root.querySelector('[data-lm-ewd-minutes]');
  const secondsNode=root.querySelector('[data-lm-ewd-seconds]');
  if(!daysNode||!hoursNode||!minutesNode||!secondsNode)return;
  let previousOverflow='';
  let countdownInterval=0;
  let openTimer=0;
  const pad=n=>String(n).padStart(2,'0');
  const canShow=()=>{
    if(designMode)return true;
    try{const seen=Number(localStorage.getItem(storageKey)||0);return !seen||(Date.now()-seen)>repeatMs}catch(e){return true}
  };
  const close=()=>{
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden','true');
    document.body.style.overflow=previousOverflow;
    if(!designMode){try{localStorage.setItem(storageKey,String(Date.now()))}catch(e){}}
  };
  const open=()=>{
    if(!canShow()||(!designMode&&Date.now()>=campaignEndsAt))return;
    previousOverflow=document.body.style.overflow;
    document.body.style.overflow='hidden';
    root.classList.add('is-open');
    root.setAttribute('aria-hidden','false');
    closeButton?.focus({preventScroll:true});
  };
  const updateCountdown=()=>{
    const remaining=Math.max(0,campaignEndsAt-Date.now());
    const totalSeconds=Math.floor(remaining/1000);
    daysNode.textContent=pad(Math.floor(totalSeconds/86400));
    hoursNode.textContent=pad(Math.floor((totalSeconds%86400)/3600));
    minutesNode.textContent=pad(Math.floor((totalSeconds%3600)/60));
    secondsNode.textContent=pad(totalSeconds%60);
    if(remaining<=0){window.clearInterval(countdownInterval);countdownInterval=0;if(!designMode)close()}
  };
  closeButton?.addEventListener('click',close);
  root.addEventListener('click',event=>{if(event.target===root)close()});
  root._lmEwdEscape=event=>{if(event.key==='Escape'&&root.classList.contains('is-open'))close()};
  document.addEventListener('keydown',root._lmEwdEscape);
  copyButton?.addEventListener('click',async()=>{
    const original=copyButton.dataset.lmCopyLabel||copyButton.textContent;
    try{
      await navigator.clipboard.writeText('EMIRATI30');
      copyButton.textContent=copyButton.dataset.lmCopiedLabel||'Copied';
      window.setTimeout(()=>{copyButton.textContent=original},1800);
    }catch(e){copyButton.textContent='EMIRATI30';window.setTimeout(()=>{copyButton.textContent=original},1800)}
  });
  updateCountdown();
  countdownInterval=window.setInterval(updateCountdown,1000);
  openTimer=window.setTimeout(open,designMode?600:3500);
  root._lmEwdCleanup=()=>{window.clearInterval(countdownInterval);window.clearTimeout(openTimer);document.removeEventListener('keydown',root._lmEwdEscape)};
}
function initAll(scope=document){scope.querySelectorAll?.(SELECTOR).forEach(init);if(scope.matches?.(SELECTOR))init(scope)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll(),{once:true});else initAll();
document.addEventListener('shopify:section:load',event=>initAll(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll?.(SELECTOR).forEach(root=>root._lmEwdCleanup?.()));
})();
